<template>
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn icon dark @click="close()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Send Message - {{premise.name}}</v-toolbar-title>
        </v-toolbar>
        <div v-if="loading" style="text-align: center; margin-top:200px">
            <v-progress-circular
                    :width="3"
                    color="green"
                    indeterminate=""/>
        </div>
        <div v-if="!loading">
            <v-form ref="searchIncidentsForm" @submit.prevent="submitMessage">
                <v-card-text>
                    <v-container fluid>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-select v-model="selectedContactLists"
                                          label="Contact Lists"
                                          multiple
                                          chips
                                          :items="contactLists"
                                          item-text="name"
                                          item-value="id"
                                          persistent-hint
                                          deletable-chips
                                          append-icon="mdi-magnify"></v-select>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea v-model="message" outlined label="Message"></v-textarea>
                            </v-flex>
                            <v-flex xs12>
                              <v-checkbox label="Send as Critical Alert (iOS Users Only)"
                                          v-model="critical"
                                          counter="100"
                              ></v-checkbox>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-btn outlined type="button" @click="close()" color="warning" :disabled="overlay">Cancel</v-btn>
                    <v-btn outlined type="submit" color="success" :disabled="overlay">Save</v-btn>
                    <v-progress-circular
                            :width="3"
                            v-show="overlay"
                            color="red"
                            indeterminate="">
                    </v-progress-circular>
                </v-card-actions>
            </v-form>
        </div>
    </v-card>
</template>

<script>

    import api from '@/api';

    export default {
        name: "SendMessage",
        data () {
            return {
                premiseId: null,
                premise : {},
                contactLists: [],
                selectedContactLists : [],
                message : null,
                overlay : false,
                loading : true,
                critical : false
            }
        },
        methods : {
            reset() {
                this.premiseId = null;
                this.premise = {};
                this.contactLists = null;
                this.selectedContactLists = null;
                this.message = null;
                this.loading = true;
                this.critical = false;
            },
            close() {
                this.$emit('close');
                this.reset();
            },
            open(premiseId) {
                this.premiseId = premiseId;

                this.getData().then(()=> {
                    let filteredCl = []
                    this.contactLists.forEach((c) => {
                        if (c.users && c.users.length > 0) {
                            filteredCl.push({
                               id : c.id,
                               name : c.name
                            });
                        }
                    })
                    this.contactLists = filteredCl;
                    this.selectedContactLists = filteredCl.map((c) => {
                        return c.id;
                    });
                    this.loading = false;
                },() => {
                    alert("Error Loading Required Data");
                })
            },
            getData() {
                return new Promise((resolve,reject) => {
                    api.premise.get(this.premiseId).then((data) => {
                        this.premise = data;
                        api.premise.contactList.get(this.premiseId).then((data) => {
                            this.contactLists = data;
                            resolve();
                        }, reject);
                    });
                });
            },
            submitMessage() {
                let obj = {
                    message:this.message,
                    contactListIds : this.selectedContactLists,
                    premiseId : this.premiseId,
                    critical : this.critical
                };
                if (!obj.message || obj.message === '') {
                    return;
                }
                if (!obj.contactListIds || obj.contactListIds.length == 0) {
                    return;
                }
                this.overlay = true;
                api.firstAlert.announcement.post(this.premiseId,obj).then((data) => {
                    this.$root.$emit('globalMessage','Message Sent');
                    this.message = '';
                },() => {
                    this.$root.$emit('globalError','Unexpected Error Sending Message');
                }).finally(()=> {
                    this.overlay = false;
                })
            }
        }
    }
</script>

<style scoped>

</style>